'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slateEditTable = require('@gitbook/slate-edit-table');

var _slateEditTable2 = _interopRequireDefault(_slateEditTable);

var _slateSoftBreak = require('slate-soft-break');

var _slateSoftBreak2 = _interopRequireDefault(_slateSoftBreak);

var _AlignPlugin = require('./plugins/AlignPlugin');

var _AlignPlugin2 = _interopRequireDefault(_AlignPlugin);

var _EditListPlugin = require('./plugins/EditListPlugin');

var _EditListPlugin2 = _interopRequireDefault(_EditListPlugin);

var _KeyPlugin = require('./plugins/KeyPlugin');

var _KeyPlugin2 = _interopRequireDefault(_KeyPlugin);

var _RenderPlugin = require('./plugins/RenderPlugin');

var _RenderPlugin2 = _interopRequireDefault(_RenderPlugin);

var _TablePlugin = require('./plugins/TablePlugin');

var _TablePlugin2 = _interopRequireDefault(_TablePlugin);

var _VoidPlugin = require('./plugins/VoidPlugin');

var _VoidPlugin2 = _interopRequireDefault(_VoidPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopicConfiguration = {
  plugins: [(0, _KeyPlugin2.default)(), (0, _TablePlugin2.default)(), (0, _AlignPlugin2.default)(), (0, _VoidPlugin2.default)({ type: 'horizontal-rule', tag: 'hr' }), (0, _VoidPlugin2.default)({ type: 'underbar', tag: 'span', attributes: { className: 'underbar' } }), (0, _VoidPlugin2.default)({ type: 'underbar_l', tag: 'span', attributes: { className: 'underbar_l' } }), (0, _VoidPlugin2.default)({ type: 'underbar_xl', tag: 'span', attributes: { className: 'underbar_xl' } }), (0, _RenderPlugin2.default)(), (0, _slateSoftBreak2.default)({ shift: true, onlyIn: ['paragraph', 'table_cell'] }), (0, _slateEditTable2.default)(), _EditListPlugin2.default],

  // Enforce no marks on a header
  schema: {
    blocks: {
      'heading-one': {
        marks: [{}],
        nodes: [{ objects: ['text'] }]
      },
      'heading-two': {
        marks: [{}],
        nodes: [{ objects: ['text'] }]
      }
    }
  }
};

exports.default = TopicConfiguration;